var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_vm.loading || _vm.error ? _c('LoaderIcon', {
    staticClass: "m-auto",
    attrs: {
      "error": _vm.error,
      "error-message": "This referral is no longer available, either because it expired or another MLO was selected.  It has been removed from Network Connect."
    }
  }) : _c('div', [_c('GrayHeader', [_c('MottoBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Network Connect',
        routeName: 'network-connect',
        routeParams: {
          selectedTab: _vm.isOfficeReferral ? 'office_sent' : 'sent'
        }
      }, {
        label: "Referral - ".concat(_vm.referralIdentifier)
      }],
      "back-route": 'network-connect',
      "back-route-params": {
        selectedTab: _vm.isOfficeReferral ? 'office_sent' : 'sent'
      }
    }
  }), _c('BaseTitle', {
    staticClass: "gray-header-title"
  }, [_vm._v("Referral - " + _vm._s(_vm.referralIdentifier))]), _c('p', {
    staticClass: "d-block d-lg-none mt-3 color-secondary-light-blue"
  }, [_vm._v(_vm._s(_vm.getStatusTooltipText(_vm.referral.status)))])], 1), _c('FormItemGroup', [_c('FormItem', {
    attrs: {
      "label": "Borrower First Name",
      "value": _vm.referral.borrowerFirstName
    }
  }), _c('FormItem', {
    attrs: {
      "label": "Borrower Last Name",
      "value": _vm.referral.borrowerLastName
    }
  }), _c('div')], 1), _c('FormItemGroup', [_c('FormItem', {
    attrs: {
      "label": "Subject Property Address State",
      "value": _vm.referral.state
    }
  }), _c('FormItem', {
    attrs: {
      "label": "Loan Type",
      "value": _vm.referral.loanType
    }
  }), _c('FormItem', {
    attrs: {
      "label": "Loan Amount",
      "value": _vm.referral.loanAmount
    }
  })], 1), !_vm.isUserSender ? _c('FormItemGroup', [_c('FormItem', {
    attrs: {
      "label": "Sender Name",
      "value": _vm.referral.createdBy.name
    }
  }), _c('FormItem', {
    attrs: {
      "label": "Sender Email",
      "value": _vm.referral.createdBy.email
    }
  }), _c('FormItem', {
    attrs: {
      "label": "Sender Phone",
      "value": _vm.referral.createdBy.phone
    }
  })], 1) : _vm._e(), _c('FormItemGroup', [_c('FormItem', {
    attrs: {
      "label": "Date Sent",
      "value": _vm.referral.sentDateStr
    }
  }), _c('div', {
    staticClass: "position-relative d-flex"
  }, [_c('FormItem', {
    attrs: {
      "label": "Status",
      "value": _vm.referral.status
    }
  }), _vm.getStatusTooltipText(_vm.referral.status) ? _c('Tooltip', {
    class: _vm.$style.statusTooltip,
    attrs: {
      "target": "".concat(_vm.referral.id),
      "placement": "top",
      "theme": "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm.getStatusTooltipText(_vm.referral.status)) + " ")]) : _vm._e()], 1), _vm.referral.referralType === 'State-wide' ? _c('FormItem', {
    attrs: {
      "label": "Recipients",
      "value": _vm.referral.referralType
    }
  }) : _c('div')], 1), _vm.referral.status === 'Completed' ? _c('FormItemGroup', [_c('FormItem', {
    attrs: {
      "label": "Recipient Name",
      "value": _vm.getAcceptedUserForCompletedReferral(_vm.referral).name
    }
  }), _c('FormItem', {
    attrs: {
      "label": "Recipient Work line",
      "value": _vm.getAcceptedUserForCompletedReferral(_vm.referral).phone
    },
    scopedSlots: _vm._u([{
      key: "afterValue",
      fn: function fn() {
        return [_vm.referral.status === 'Completed' && _vm.getAcceptedUserForCompletedReferral(_vm.referral).phone ? _c('a', {
          class: _vm.$style.contactIcon,
          attrs: {
            "href": "tel:".concat(_vm.getAcceptedUserForCompletedReferral(_vm.referral).phone || '')
          }
        }, [_c('MottoIcon', {
          staticClass: "ml-2",
          attrs: {
            "id": "phone".concat(_vm.referral.id),
            "name": "Phone",
            "icon-color": "orange"
          }
        })], 1) : _vm._e(), _c('b-tooltip', {
          attrs: {
            "target": "phone".concat(_vm.referral.id),
            "placement": "top",
            "custom-class": "tooltipBlue"
          }
        }, [_vm._v(" Call referree’s work line ")])];
      },
      proxy: true
    }], null, false, 3231080297)
  }), _c('FormItem', {
    attrs: {
      "label": "Recipient Email",
      "value": _vm.getAcceptedUserForCompletedReferral(_vm.referral).email
    },
    scopedSlots: _vm._u([{
      key: "afterValue",
      fn: function fn() {
        return [_vm.referral.status === 'Completed' && _vm.getAcceptedUserForCompletedReferral(_vm.referral).email ? _c('a', {
          class: _vm.$style.contactIcon,
          attrs: {
            "href": "mailto:".concat(_vm.getAcceptedUserForCompletedReferral(_vm.referral).email, "?subject=Completed ").concat(_vm.referral.state || '', " ").concat(_vm.referral.loanType || '', " deal level referral")
          }
        }, [_c('MottoIcon', {
          staticClass: "ml-2",
          attrs: {
            "id": "envelope".concat(_vm.referral.id),
            "name": "Envelope",
            "icon-color": "orange"
          }
        }), _c('b-tooltip', {
          attrs: {
            "target": "envelope".concat(_vm.referral.id),
            "placement": "top",
            "custom-class": "tooltipBlue"
          }
        }, [_vm._v(" Email referree ")])], 1) : _vm._e()];
      },
      proxy: true
    }], null, false, 3822479084)
  })], 1) : _vm._e(), (_vm.referral.referralType !== 'State-wide' || _vm.referralAcceptedRecipients.length > 0) && _vm.referral.recipients.length > 0 ? [_c('div', {
    staticClass: "position-relative"
  }, [_c('p', {
    staticClass: "p1 mt-10 mb-10 color-dark-gray"
  }, [_vm._v(_vm._s(_vm.amountOfRecipientsSentence) + ":")]), _vm.getRecipientType === 'user' ? _c('p', {
    staticClass: "p1 color-dark-gray",
    class: _vm.$style.recipientResponseText
  }, [_vm._v(" Recipient Response: ")]) : _vm._e(), _c('div', {
    class: _vm.$style.searchResultsContainer
  }, _vm._l(_vm.referralRecipients.map(function (referralRecipient) {
    return Object.assign({}, referralRecipient, {
      recipientType: _vm.getRecipientType
    });
  }), function (recipient) {
    return _c('SearchRecipientResult', {
      key: recipient.id,
      attrs: {
        "recipient": recipient,
        "disabled": ""
      },
      scopedSlots: _vm._u([_vm.getRecipientType === 'user' ? {
        key: "actionButton",
        fn: function fn() {
          return [_c('div', {
            class: _vm.$style.selectButtonContainer
          }, [_c('p', {
            staticClass: "text-align-left p1 color-dark-gray"
          }, [_vm._v(" " + _vm._s(recipient.recipientResponse) + " ")]), _vm.referral.status !== 'Completed' ? _c('BaseButton', {
            attrs: {
              "options": {
                defaultPadding: true
              },
              "theme": "green",
              "disabled": _vm.disableAcceptanceButtons || !(_vm.isUserSender && _vm.referralAcceptedRecipientsIds.includes(recipient.id))
            },
            on: {
              "click": function click($event) {
                return _vm.acceptReferralRecipient(recipient);
              }
            }
          }, [_vm._v(" Select ")]) : _vm._e()], 1)];
        },
        proxy: true
      } : null], null, true)
    });
  }), 1)]), _c('div', {
    class: _vm.$style.selectedRecipientsTags
  }, _vm._l(_vm.referralRecipients, function (recipient) {
    return _c('TagSelector', {
      key: recipient.id,
      attrs: {
        "removable": false
      }
    }, [_vm._v(" " + _vm._s(recipient.name || recipient.tradeName) + " ")]);
  }), 1)] : _vm._e(), _vm.isUserSender && (_vm.referral.status === 'Expired' || _vm.referral.status === 'Declined') ? _c('div', {
    class: _vm.$style.bottomButtonsContainer
  }, [_c('BaseButton', {
    attrs: {
      "options": {
        defaultPadding: true
      }
    },
    on: {
      "click": _vm.resendReferral
    }
  }, [_vm._v("Resend Referral")])], 1) : _vm._e()], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }